/* eslint-disable max-len */
export default class ReduChartLight {
  constructor() {
    this.elements = document.querySelectorAll('.js--reduchart-light');

    for (let i = 0; i < this.elements.length; i++) {
      this.drawChart(i);
    }
  }

  drawChart(i) {
    const element = this.elements[i];
    const radiationDataSet = graphDataSet['advice' + element.dataset.advice].radiation;
      const maxRadiation = Math.max.apply(Math, radiationDataSet);

      const reduchart = new Chart(element, {
      type: 'line',
      data: {
        datasets: [{
          borderColor: '#84BD00',
          pointRadius: 0,
          fill: false,
          data: radiationDataSet,
          borderWidth: 4,
          lineTension: 0.4,
        }],
        labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        chartArea: {
          backgroundColor: '#F7F7F7',
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
            mode: 'index',
            intersect: false
        },
          hover: {
              mode: 'index',
              intersect: false
          },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 4,
            bottom: 0,
          },
        },
        scales: {
          xAxes: [{
            position: top,
            gridLines: {
              offsetGridLines: true,
              color: '#FFFFFF',
              lineWidth: 18,
              drawBorder: false,
              drawTicks: false,
            },
            ticks: {
              display: false,
              padding: -280,
              fontSize: 20,
            },
          }],
          yAxes: [{
            gridLines: {
              display: false,
              drawBorder: false,
              drawTicks: false,
              zeroLineWidth: 0,
            },
            ticks: {
              display: false,
              max: (maxRadiation + 500)
            },
          }],
        },

      },
    });
  }
}
